import browserPersistence from "@/utils/session-persistance";

const sessionStorage = new browserPersistence();

type KEY =
  | "DUKE_BROWSER_PERSISTENCE"
  | "DUKE_ACTIVE_QUOTE"
  | "DUKE_CACHE_STORAGE"
  | "QUOTE_PRICES"
  | "GLOBAL_OPTION_RESOURCES"
  | "BODY_OPTIONS_RESOURCES"
  | "DUKE_FORM_DATA"
  | "MODEL_OPTION_DEPENDENCY"
  | "DUKE_GENERAL_BY_ATTRIBUTE_SET";

const set = (key: KEY, data: any): void => {
  sessionStorage.setItem(key, data);
};

const get = (key: KEY): any => {
  return sessionStorage.getItem(key);
};

const omit = (key: KEY): void => {
  sessionStorage.removeItem(key);
};

const store = {
  set,
  get,
  omit,
};

export default store;
